<p>
  Logging out...
</p>
